import moment from 'moment';

export default function formatDate(date: string, format = 'DD/MMM/YYYY') {
  if (!date) return '--';
  const formattedDate = moment(date).format(format);
  if (parseInt(formattedDate.split('/')[2]) === 1900) return '--';
  return formattedDate;
}

export function formatDateWithTime(date: string, format = 'DD/MMM/YYYY HH:mm:ss') {
  if (!date) return '--';
  const formattedDate = moment(date).utc().local().format(format);
  if (parseInt(formattedDate.split('/')[2]) === 1900) return '--';
  return formattedDate; 
}

export function setDaysInDate(date: string, days: number) : Date {
  return moment(date).add(days, 'days').toDate();;
}

export function dateDiff(dateFrom: string, dateTo: string) : number {
  return moment(dateFrom).diff(new Date(dateTo), 'days') * -1;
}